<template>
  <div>
    <app-form
      v-bind:parentObject="{
        data: this.formData,
        pageTitle: this.pageTitle,
        pageTitleValue: this.pageTitleValue,
        errMsg: this.errMsg,
        isEdit: this.editMode,
      }"
      v-on:input="formData = $event"
      v-on:save="saveHandler"
    />
    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>
  </div>
</template>

<script>

import BankAccountForm from "../../../components/payroll/bankaccount/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
  components: {
    "app-form": BankAccountForm,
    "app-error": ErrorDialog,
  },

  data() {
    return {
      pageTitle: this.$t('setupcompanybankaccount.createnewbankaccount'),
      pageTitleValue: "",
      formData: {
        accountcode: null,
        accountdesc: null,
        bankid: null,
        expformatid: null,
        accountno: null,
        officer: null,
        tel: null,
        email: null,
        addr1: null,
        addr2: null,
        addr3: null,
        cityid: null,
        cntryid: null,
        crcyid: null,
        stamp: 0,
        userid: this.$store.getters.userId,
        custid: null,
        accountid: null,
        intsettingid: null,
      },

      countryList: [],
      cityList: [],
      currencyList: [],
      bankList: [],
      expformatList: [],

      countries: [],
      cities: [],
      currencies: [],
      banks: [],
      expformats: [],

      errMsg: "",
      isErr: false,
      editMode: false,
    };
  },

  methods: {
    saveHandler() {
      const vm = this;
      if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
        return false;
      }
      this.$store.dispatch('post', {url: "/bankaccount/create", payload: vm.formData})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = true;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "bankaccountlist" });
          }
        })
        .catch((err) => {
          vm.isErr = true;
          vm.errMsg = err;
        });
    },

    cancelHandler() {
      this.$router.push({ name: "bankaccountlist" });
    },
  },
};
</script>